









































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import { required } from 'vuelidate/lib/validators';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import GVTag from '@/components/GVTag.vue';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GJgrowEventCreateTermEventDate',
  components: { GVTag, GJgrowEventCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    startDate: { required },
    endDate: { required },
  },
})
export default class GJgrowEventCreateTermEventDate extends mixins(GPageBase) {
  isStartDateChange: boolean = false;
  mounted() {}

  get startDate(): Date {
    return this.eventParam.startDate;
  }

  get endDate(): Date {
    return this.eventParam.endDate;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get isStartDateInvalid(): boolean {
    return this.$v.startDate.$dirty && this.$v.startDate.$invalid;
  }
  get isStartDateBeforeCurrentTime(): boolean {
    return moment(this.eventParam.startDate) <= moment(new Date()).add(-5, 'm');
  }

  get isEndDateInvalid(): boolean {
    return this.$v.endDate.$dirty && this.$v.endDate.$invalid;
  }

  get isEndDateBeforeStartTime(): boolean {
    return !this.$v.startDate.$invalid && !this.$v.endDate.$invalid && moment(this.eventParam.endDate) <= moment(this.eventParam.startDate);
  }

  touchDeadline(): void {
    this.$v.endDate.$touch();
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return (date && moment(date) < moment(startDate).add(-1, 'd')) || moment(new Date(globalModule.selectedSchoolYear + 1, 3, 1)) <= moment(date);
      },
    };
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト(終了日は無期限)
  get dateForeverOption() {
    const startDate: Date = new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return date && moment(date) < moment(startDate).add(-1, 'd');
      },
    };
  }

  /**
   * 開始時間変更時
   */
  handleStartDateChange(value: string) {
    this.isStartDateChange = true;
    this.eventParam.startDate = value === '' ? null : moment(value).toDate();
    this.$v.startDate.$touch();
  }

  /**
   * 終了時間変更時
   */
  handleEndDateChange(value: string) {
    this.eventParam.endDate = value === '' ? null : moment(value).toDate();
    this.touchDeadline();
  }

  touch() {
    this.$v.$touch();
  }

  /**
   * バリデーション
   * 他の「アンケート日付」「受検（測定）日付」に関わらず、
   * イベントの終了日が開始日より未来であることをチェックする
   */
  isValid(): boolean {
    return !this.isStartDateInvalid && !this.isEndDateInvalid && !this.isEndDateBeforeStartTime;
  }
}
